import { Map } from 'immutable';

export const redVarietals = [
  'Cabernet Sauvignon',
  'Dessert',
  'Malbec',
  'Merlot',
  'Pinot Noir',
  'Red Blend',
  // 'Syrah',
  'Zinfandel',
];
export const whiteVarietals = [
  'Chardonnay',
  'Fumé Blanc',
  'Pinot Grigio',
  'Muscat Canelli',
  'Riesling',
  'Sauvignon Blanc',
];
export const allGiftCategories = [
  'Wine Sets',
  'Gifts for Her',
  'Gifts for Him',
  'Special Occasions',
  'No Alcohol',
  'Pets',
]; // 'Seasonal',
export const allTypes = ['Red', 'White', 'Sparkling', 'Rosé'];
export const filterCauses = [
  'Animals',
  'Children',
  'Education',
  'Environment',
  'Global',
  'Health',
  'Veterans',
  'Women',
];
export const filterPrices = [
  'Under $20',
  '$20—$40',
  '$40—$60',
  '$60—$80',
  '$80—$100',
  'Over $100',
];
export const allVarietals = redVarietals.concat(whiteVarietals);
export const allCategories = allVarietals
  .concat(allGiftCategories)
  .concat(allTypes)
  .concat(filterCauses)
  .concat(filterPrices);
export const filterCategories = {
  type: allTypes,
  whiteVarietals,
  redVarietals,
  varietal: allVarietals,
  price: filterPrices,
  cause: filterCauses,
  categories: allCategories,
  giftCategories: allGiftCategories,
};

export const allVarietalsAndTypes = allVarietals.concat(filterCategories.type);

export const varietalFilterCategories = {
  wine: true,
  'wine-white': true,
  'wine-red': true,
  'wine-collection-reserve': true,
  'wine-collection-core': true,
  'wine-collection-vintner': true,
};

export const typeFilterCategories = {
  wine: true,
  'wine-collection-reserve': true,
  'wine-collection-core': true,
  'wine-collection-vintner': true,
  'wine-glitter': true,
};

export const disableWhiteVarietals = {
  Chardonnay: true,
  'Fumé Blanc': true,
  'Sauvignon Blanc': true,
  Riesling: true,
  'Muscat Canelli': true,
  'Pinot Grigio': true,
};

export const disableRedVarietals = {
  Dessert: true,
  Malbec: true,
  Merlot: true,
  // Syrah: true,
  Zinfandel: true,
  'Cabernet Sauvignon': true,
  'Pinot Noir': true,
  'Red Blend': true,
};

export const enableAllVarietals = Map({
  Chardonnay: false,
  'Fumé Blanc': false,
  'Sauvignon Blanc': false,
  Riesling: false,
  'Muscat Canelli': false,
  'Pinot Grigio': false,
  Dessert: false,
  Malbec: false,
  Merlot: false,
  // Syrah: false,
  Zinfandel: false,
  'Cabernet Sauvignon': false,
  'Pinot Noir': false,
  'Red Blend': false,
});

export const disableAllVarietals = Map({
  Chardonnay: true,
  'Fumé Blanc': true,
  'Sauvignon Blanc': true,
  Riesling: true,
  'Muscat Canelli': true,
  'Pinot Grigio': true,
  Dessert: true,
  Malbec: true,
  Merlot: true,
  // Syrah: true,
  Zinfandel: true,
  'Cabernet Sauvignon': true,
  'Pinot Noir': true,
  'Red Blend': true,
});

export const newFilterState = Map({
  isDataLoading: false,
  filterSelection: 'type',
  sortSelection: 'bestSellers',
  category: 'wine',
  resetState: true,
  relayFilterVariables: Map({
    sortBy: 'bestSellers',
    filterPrice: ['any'],
    filterByVarietal: ['any'],
    filterByCause: ['any'],
    filterByType: ['any'],
    filterByGiftCategories: ['any'],
  }),
  wineTypes: Map({
    Red: false,
    White: false,
    Sparkling: false,
    Rosé: false,
  }),
  wineVarietals: Map({
    Chardonnay: false,
    Dessert: false,
    Malbec: false,
    Merlot: false,
    Riesling: false,
    // Syrah: false,
    Zinfandel: false,
    'Fumé Blanc': false,
    'Sauvignon Blanc': false,
    'Cabernet Sauvignon': false,
    'Muscat Canelli': false,
    'Pinot Grigio': false,
    'Pinot Noir': false,
    'Red Blend': false,
  }),
  causes: Map({
    Animals: false,
    Children: false,
    Education: false,
    Environment: false,
    Global: false,
    Health: false,
    Veterans: false,
    Women: false,
  }),
  categoryStates: Map({
    Animals: false,
    Children: false,
    Education: false,
    Environment: false,
    Global: false,
    Health: false,
    Veterans: false,
    Women: false,
    Red: false,
    White: false,
    Sparkling: false,
    Chardonnay: false,
    Dessert: false,
    Malbec: false,
    Merlot: false,
    Riesling: false,
    // Syrah: false,
    Zinfandel: false,
    Rosé: false,
    'Fumé Blanc': false,
    'Sauvignon Blanc': false,
    'Cabernet Sauvignon': false,
    'Muscat Canelli': false,
    'Pinot Grigio': false,
    'Pinot Noir': false,
    'Red Blend': false,
    'Under $20': false,
    '$20—$40': false,
    '$40—$60': false,
    '$60—$80': false,
    '$80—$100': false,
    'Over $100': false,
    'Wine Sets': false,
    'Gifts for Her': false,
    'Gifts for Him': false,
    'Special Occasions': false,
    Seasonal: false,
    Pets: false,
    'No Alcohol': false,
  }),
  giftCategories: Map({
    'Wine Sets': false,
    'Gifts for Her': false,
    'Gifts for Him': false,
    'Special Occasions': false,
    Seasonal: false,
    Pets: false,
    'No Alcohol': false,
  }),
  prices: Map({
    'Under $20': false,
    '$20—$40': false,
    '$40—$60': false,
    '$60—$80': false,
    '$80—$100': false,
    'Over $100': false,
  }),
  disabledVarietals: Map({
    Chardonnay: false,
    'Fumé Blanc': false,
    'Sauvignon Blanc': false,
    Riesling: false,
    'Muscat Canelli': false,
    'Pinot Grigio': false,
    Dessert: false,
    Malbec: false,
    Merlot: false,
    // Syrah: false,
    Zinfandel: false,
    'Cabernet Sauvignon': false,
    'Pinot Noir': false,
    'Red Blend': false,
  }),
});

export const newRedFilterState = Map({
  isDataLoading: false,
  filtersApplied: false,
  filterSelection: 'type',
  sortSelection: 'lowPrice',
  category: 'wine',
  resetState: true,
  relayFilterVariables: Map({
    sortBy: 'bestSellers',
    filterPrice: ['any'],
    filterByVarietal: ['any'],
    filterByCause: ['any'],
    filterByType: ['any'],
    filterByGiftCategories: ['any'],
  }),
  wineTypes: Map({
    Red: false,
    White: false,
    Sparkling: false,
    Rosé: false,
  }),
  wineVarietals: Map({
    Chardonnay: false,
    Dessert: false,
    Malbec: false,
    Merlot: false,
    Riesling: false,
    // Syrah: false,
    Zinfandel: false,
    'Fumé Blanc': false,
    'Sauvignon Blanc': false,
    'Cabernet Sauvignon': false,
    'Muscat Canelli': false,
    'Pinot Grigio': false,
    'Pinot Noir': false,
    'Red Blend': false,
  }),
  causes: Map({
    Animals: false,
    Children: false,
    Environment: false,
    Education: false,
    Global: false,
    Health: false,
    Veterans: false,
    Women: false,
  }),
  categoryStates: Map({
    Animals: false,
    Children: false,
    Environment: false,
    Education: false,
    Global: false,
    Health: false,
    Veterans: false,
    Women: false,
    Red: false,
    White: false,
    Sparkling: false,
    Chardonnay: false,
    Dessert: false,
    Malbec: false,
    Merlot: false,
    Riesling: false,
    // Syrah: false,
    Zinfandel: false,
    Rosé: false,
    'Fumé Blanc': false,
    'Sauvignon Blanc': false,
    'Cabernet Sauvignon': false,
    'Muscat Canelli': false,
    'Pinot Grigio': false,
    'Pinot Noir': false,
    'Red Blend': false,
    'Under $20': false,
    '$20—$40': false,
    '$40—$60': false,
    '$60—$80': false,
    '$80—$100': false,
    'Over $100': false,
    'Wine Sets': false,
    'Gifts for Her': false,
    'Gifts for Him': false,
    'Special Occasions': false,
    Seasonal: false,
    Pets: false,
    'No Alcohol': false,
  }),
  giftCategories: Map({
    'Wine Sets': false,
    'Gifts for Her': false,
    'Gifts for Him': false,
    'Special Occasions': false,
    Seasonal: false,
    Pets: false,
    'No Alcohol': false,
  }),
  prices: Map({
    'Under $20': false,
    '$20—$40': false,
    '$40—$60': false,
    '$60—$80': false,
    '$80—$100': false,
    'Over $100': false,
  }),
  disabledVarietals: Map({
    Chardonnay: false,
    'Fumé Blanc': false,
    'Sauvignon Blanc': false,
    Riesling: false,
    'Muscat Canelli': false,
    'Pinot Grigio': false,
    Dessert: true,
    Malbec: true,
    Merlot: true,
    // Syrah: true,
    Zinfandel: true,
    'Cabernet Sauvignon': true,
    'Pinot Noir': true,
    'Red Blend': true,
  }),
});

export const newWhiteFilterState = Map({
  filtersApplied: false,
  filterSelection: 'type',
  sortSelection: 'bestSellers',
  category: 'wine',
  resetState: true,
  relayFilterVariables: Map({
    sortBy: 'bestSellers',
    filterPrice: ['any'],
    filterByVarietal: ['any'],
    filterByCause: ['any'],
    filterByType: ['any'],
    filterByGiftCategories: ['any'],
  }),
  wineTypes: Map({
    Red: false,
    White: false,
    Sparkling: false,
    Rosé: false,
  }),
  wineVarietals: Map({
    Chardonnay: false,
    Dessert: false,
    Malbec: false,
    Merlot: false,
    Riesling: false,
    // Syrah: false,
    Zinfandel: false,
    'Fumé Blanc': false,
    'Sauvignon Blanc': false,
    'Cabernet Sauvignon': false,
    'Muscat Canelli': false,
    'Pinot Grigio': false,
    'Pinot Noir': false,
    'Red Blend': false,
  }),
  causes: Map({
    Animals: false,
    Children: false,
    Environment: false,
    Education: false,
    Global: false,
    Health: false,
    Veterans: false,
    Women: false,
  }),
  categoryStates: Map({
    Animals: false,
    Children: false,
    Environment: false,
    Education: false,
    Global: false,
    Health: false,
    Veterans: false,
    Women: false,
    Red: false,
    White: false,
    Sparkling: false,
    Chardonnay: false,
    Dessert: false,
    Malbec: false,
    Merlot: false,
    Riesling: false,
    // Syrah: false,
    Zinfandel: false,
    Rosé: false,
    'Fumé Blanc': false,
    'Sauvignon Blanc': false,
    'Cabernet Sauvignon': false,
    'Muscat Canelli': false,
    'Pinot Grigio': false,
    'Pinot Noir': false,
    'Red Blend': false,
    'Under $20': false,
    '$20—$40': false,
    '$40—$60': false,
    '$60—$80': false,
    '$80—$100': false,
    'Over $100': false,
    'Wine Sets': false,
    'Gifts for Her': false,
    'Gifts for Him': false,
    'Special Occasions': false,
    Seasonal: false,
    Pets: false,
    'No Alcohol': false,
  }),
  giftCategories: Map({
    'Wine Sets': false,
    'Gifts for Her': false,
    'Gifts for Him': false,
    'Special Occasions': false,
    Seasonal: false,
    Pets: false,
    'No Alcohol': false,
  }),
  prices: Map({
    'Under $20': false,
    '$20—$40': false,
    '$40—$60': false,
    '$60—$80': false,
    '$80—$100': false,
    'Over $100': false,
  }),
  disabledVarietals: Map({
    Chardonnay: true,
    'Fumé Blanc': true,
    'Sauvignon Blanc': true,
    Riesling: true,
    'Muscat Canelli': true,
    'Pinot Grigio': true,
    Dessert: false,
    Malbec: false,
    Merlot: false,
    // Syrah: false,
    Zinfandel: false,
    'Cabernet Sauvignon': false,
    'Pinot Noir': false,
    'Red Blend': false,
  }),
});
